import { useCallback, useContext, useState } from "react";

import { Button, IconGoogle } from "../../../components/atoms";
import {
  FlatpickerHourGroup,
  SelectGroup,
} from "../../../components/molecules";
import { AuthContext } from "../../../contexts/Auth/AuthContext";
import { NotificationContext } from "../../../contexts/NotificationCTX/NotificationContext";
import { api, convertDateTimeToPattern as dateFormat } from "../../../helpers";
import JanelaRelatorio from "./JanelaRelatorio";

import GraficoGerencial from "./GraficoGerencial";

import { GraficoGerencialResponse, TipoRelatorioGrafico } from "./types";

export function Gerencial() {
  const { applicationData } = useContext(AuthContext);

  const {
    setType,
    setShow,
    setText: setTextAlert,
  } = useContext(NotificationContext);

  const [campoObrigatorioDataInicial, setcampoObrigatorioDataInicial] =
    useState<boolean>(false);

  const [campoObrigatorioDataFinal, setcampoObrigatorioDataFinal] =
    useState<boolean>(false);

  const [campoObrigatorioTipoPeriodo, setcampoObrigatorioTipoPeriodo] =
    useState<boolean>(false);

  const [campoObrigatorioRelatorio, setcampoObrigatorioRelatorio] =
    useState<boolean>(false);

  const [dataInicial, setDataInicial] = useState<Date>(new Date());
  const [dataFinal, setDataFinal] = useState<Date>(new Date());

  const [origem, setOrigem] = useState("0");
  const [relatorio, setRelatorio] = useState("Faturamento");
  const [tipoperiodo, setTipoPeriodo] = useState("Horario");
  const [tipocliente, setTipoCliente] = useState("Todas");
  const [destino, setDestino] = useState("0");
  const [barco, setBarco] = useState("0");
  const [cliente, setCliente] = useState("0");

  const [dadosGrafico, setDadosGrafico] =
    useState<GraficoGerencialResponse | null>(null);
  const [carregandoGrafico, setCarregandoGrafico] = useState(false);
  const ehRelatorioGrafico =
    relatorio === "Vendas Mensais" || relatorio === "Passageiros Mensais";
  const fecharJanelaGrafico = useCallback(() => {
    setDadosGrafico(null);
  }, []);

  const validarCampos = (): boolean => {
    const dataInicialInvalida = !dataInicial;
    const dataFinalInvalida = !dataFinal;
    const tipoPeriodoInvalido = tipoperiodo === "";
    const relatorioInvalido = relatorio === "";

    setcampoObrigatorioDataInicial(dataInicialInvalida);
    setcampoObrigatorioDataFinal(dataFinalInvalida);
    setcampoObrigatorioTipoPeriodo(tipoPeriodoInvalido);
    setcampoObrigatorioRelatorio(relatorioInvalido);

    return !(
      dataInicialInvalida ||
      dataFinalInvalida ||
      tipoPeriodoInvalido ||
      relatorioInvalido
    );
  };

  const limparGrafico = () => {
    setDadosGrafico(null);
  };

  const gerarPdf = async () => {
    if (!validarCampos()) return;

    try {
      const { data: pdf } = await api.get(
        "/api/relgerencial/" +
          cliente +
          "/" +
          barco +
          "/" +
          destino +
          "/" +
          tipoperiodo +
          "/" +
          dateFormat(dataInicial) +
          "/" +
          dateFormat(dataFinal) +
          "/" +
          tipoperiodo +
          "/" +
          relatorio,
        {
          headers: {
            Authorization: `Bearer ${applicationData.token}`,
          },
          responseType: "blob",
        },
      );

      if (pdf.type !== "application/json") {
        const url = window.URL.createObjectURL(pdf);

        window.open(url, "_blank");

        window.setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 10000);
      } else {
        setType("danger");
        setTextAlert("Nenhum dado encontrado no intervalo selecionado!");
        setShow(true);
      }
    } catch (error) {
      console.error("Erro na geração do relatório:", error);

      setType("danger");
      setTextAlert("Erro na geração do relatório!");
      setShow(true);
    }
  };

  const gerarGrafico = async () => {
    if (!validarCampos()) return;

    try {
      setCarregandoGrafico(true);
      setDadosGrafico(null);

      const { data } = await api.get<GraficoGerencialResponse>(
        "/api/relgerencial",
        {
          headers: {
            Authorization: `Bearer ${applicationData.token}`,
          },
          params: {
            vendedor: cliente,
            barco,
            destino,
            origem,
            tipocliente,
            dataini: dateFormat(dataInicial),
            datafim: dateFormat(dataFinal),
            tipoperiodo,
            relatorio,
          },
        },
      );

      if (!data?.dados || data.dados.length === 0) {
        setType("danger");
        setTextAlert("Nenhum dado encontrado no intervalo selecionado!");
        setShow(true);
        return;
      }

      setDadosGrafico(data);
    } catch (error) {
      console.error("Erro ao carregar o gráfico gerencial:", error);

      setType("danger");
      setTextAlert("Erro ao carregar os dados do gráfico!");
      setShow(true);
    } finally {
      setCarregandoGrafico(false);
    }
  };

  const gerar = () => {
    if (ehRelatorioGrafico) {
      gerarGrafico();
      return;
    }

    limparGrafico();
    gerarPdf();
  };

  return (
    <div>
      <h2>Relatórios Gerenciais</h2>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-6">
          <SelectGroup
            value={relatorio}
            messageError={campoObrigatorioRelatorio ? "Campo obrigatório!" : ""}
            id="relatorio"
            label="Relatório"
            options={[
              {
                text: "FATURAMENTO",
                value: "Faturamento",
              },
              {
                text: "PASSAGEIROS",
                value: "Passageiros",
              },
              {
                text: "VENDAS MENSAIS",
                value: "Vendas Mensais",
              },
              {
                text: "PASSAGEIROS MENSAIS",
                value: "Passageiros Mensais",
              },
            ]}
            onChange={(e) => {
              const valor = e.target.value;

              setRelatorio(valor);
              setcampoObrigatorioRelatorio(valor === "");
              limparGrafico();
            }}
          />
        </div>

        <div className="col-sm-12 col-lg-6">
          <SelectGroup
            value={cliente}
            id="cliente"
            label="Cliente"
            options={applicationData.clientes.map((item: Cliente) => ({
              text: item.nome,
              value: item.codigo,
            }))}
            onChange={(e) => {
              setCliente(e.target.value);
              limparGrafico();
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <FlatpickerHourGroup
            label="Data/Hora Inicial"
            messageError={
              campoObrigatorioDataInicial ? "Campo obrigatório!" : ""
            }
            value={dataInicial}
            id="data-ini"
            onChange={([date]) => {
              if (date) {
                const novaData = new Date(date);

                novaData.setHours(0, 0, 0, 0);

                setDataInicial(novaData);
                setcampoObrigatorioDataInicial(false);
                limparGrafico();
              } else {
                setcampoObrigatorioDataInicial(true);
              }
            }}
          />
        </div>

        <div className="col-sm-12 col-lg-3">
          <FlatpickerHourGroup
            label="Data/Hora Final"
            messageError={campoObrigatorioDataFinal ? "Campo obrigatório!" : ""}
            value={dataFinal}
            id="data-fim"
            onChange={([date]) => {
              if (date) {
                const novaData = new Date(date);

                novaData.setHours(23, 59, 59, 999);

                setDataFinal(novaData);
                setcampoObrigatorioDataFinal(false);
                limparGrafico();
              } else {
                setcampoObrigatorioDataFinal(true);
              }
            }}
          />
        </div>

        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={tipoperiodo}
            messageError={
              campoObrigatorioTipoPeriodo ? "Campo obrigatório!" : ""
            }
            id="periodo"
            label="Tipo de período"
            options={[
              {
                text: "DATA DA RESERVA",
                value: "reserva.DataReserva",
              },
              {
                text: "DATA DO EMBARQUE",
                value: "Horario",
              },
            ]}
            onChange={(e) => {
              const valor = e.target.value;

              setTipoPeriodo(valor);
              setcampoObrigatorioTipoPeriodo(valor === "");
              limparGrafico();
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={origem}
            id="origem"
            label="Origem"
            options={applicationData.destinos.map((item: Destino) => ({
              text: item.nome,
              value: item.codigo,
            }))}
            onChange={(e) => {
              setOrigem(e.target.value);
              limparGrafico();
            }}
          />
        </div>

        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={destino}
            id="destino"
            label="Destino"
            options={applicationData.destinos.map((item: Destino) => ({
              text: item.nome,
              value: item.codigo,
            }))}
            onChange={(e) => {
              setDestino(e.target.value);
              limparGrafico();
            }}
          />
        </div>

        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={tipocliente}
            id="tipocliente"
            label="Tipo de Cliente"
            options={[
              {
                text: "AGÊNCIAS",
                value: "Agencias",
              },
              {
                text: "VENDAS DIRETAS",
                value: "Vendas Diretas",
              },
              {
                text: "TODAS",
                value: "Todas",
              },
            ]}
            onChange={(e) => {
              setTipoCliente(e.target.value);
              limparGrafico();
            }}
          />
        </div>

        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={barco}
            id="barco"
            label="Barco"
            options={applicationData.barcos.map((item: Barco) => ({
              text: item.nome,
              value: item.codigo,
            }))}
            onChange={(e) => {
              setBarco(e.target.value);
              limparGrafico();
            }}
          />
        </div>
      </div>

      <div className="row mt-3" />

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <Button
            appearance="success"
            onClick={gerar}
            disabled={carregandoGrafico}
          >
            {ehRelatorioGrafico
              ? carregandoGrafico
                ? "Carregando..."
                : "Gerar Gráfico"
              : "Gerar Relatório"}

            <IconGoogle>
              {ehRelatorioGrafico ? "bar_chart" : "picture_as_pdf"}
            </IconGoogle>
          </Button>
        </div>
      </div>

      {carregandoGrafico && (
        <div className="row mt-3">
          <div className="col-sm-12">Carregando gráfico...</div>
        </div>
      )}
      {dadosGrafico && ehRelatorioGrafico && (
        <JanelaRelatorio
          titulo={`Relatório - ${relatorio}`}
          onClose={fecharJanelaGrafico}
        >
          <GraficoGerencial
            relatorio={relatorio as TipoRelatorioGrafico}
            resposta={dadosGrafico}
          />
        </JanelaRelatorio>
      )}
    </div>
  );
}
